import React, { useEffect, useRef, useState } from 'react';
import { Formik, Form as FormikForm, Field, ErrorMessage } from 'formik';
import * as Yup from 'yup';
import { Row, Col, Button, Card } from 'react-bootstrap';
import PageTitle from '../../../layouts/PageTitle';
import Select from 'react-select';
import AsyncSelect from 'react-select/async';
import DatePicker from 'react-datepicker';
import { connect, useDispatch, useSelector } from 'react-redux';
import { employeeSearchAction } from '../../../../store/actions/BoxActions';
import { employeeSearchList } from '../../../../store/selectors/BoxSelectors';
import { getProfile } from '../../../../store/selectors/AuthSelectors';
import moment from 'moment';
import 'react-datepicker/dist/react-datepicker.css';
import { getTaskNumbers } from '../../../../services/TaskNumberService';
import { useLoader } from '../../../../context/LoaderCotext';
import { getMTEByEmail } from '../../../../services/MTEService';
import { getBoxFolderOfEmpByEmail } from '../../../../services/BoxFolderOfEmpService';
import Swal from 'sweetalert2';

import { clearDatabase, retrieveData, storeData } from '../../../../services/indexedDBUtils';
import {
  getBoxAuthToken,
  getBoxAuthUrl,
  getUsersSearch,
  uploadFileBatch,
} from '../../../../services/BoxService';
import { useAuth } from '../../../../context/authContext';
import Cookies from 'js-cookie';
import { createFormAction } from '../../../../store/actions/FormsActions';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { getFormById } from '../../../../services/FormService';

const validationSchema = Yup.object({
  employeeName: Yup.object().required('Required'),
  employeeNumber: Yup.string().required('Required'),
  date: Yup.date().required('Required'),
  phoneNumber: Yup.string().required('Required'),
  major: Yup.string().required('Required'),
  school: Yup.string().required('Required'),
  degreeType: Yup.string().required('Required'),
  semesterBegins: Yup.date().required('Required'),
  semesterEnds: Yup.date()
    .min(Yup.ref('semesterBegins'), 'End date must be after start date')
    .required('Required'),
  tuitionLimit: Yup.number().required('Required'),
  tuitionUsed: Yup.number()
    .max(Yup.ref('tuitionLimit'), 'Cannot exceed tuition limit')
    .required('Required'),
  status: Yup.string().required('Required'),
});

const TrainingFormEdit = ({ profile, employeeList }) => {
  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();
  const { hasPermission } = useAuth();
  const { showLoader, hideLoader } = useLoader();
  const [submitterName, setSubmitterName] = useState('');
  const [folderAPISuccess, setFolderAPISuccess] = useState(false);
  const [cookieValue, setCookieValue] = useState(Cookies.get('boxToken'));
  const [employeeDefault, setEmpListDefault] = useState([]);

  const { id } = useParams(); // Get the ID from URL

  const [initialValues, setInitialValues] = useState({
    employeeName: '', // Auto populated
    employeeNumber: '',
    date: '',
    phoneNumber: '',
    major: '',
    school: '',
    degreeType: '',
    semesterBegins: '',
    semesterEnds: '',
    tuitionLimit: '', // Pre-populated SSAI limit
    tuitionUsed: 0,
    // status: "Pending",
    boxFolderId: '0',
    boxFolderName: 'Training-Forms',
    timestamp: moment().unix(),
  });

  useEffect(() => {
    setFolderAPISuccess(true);
  }, [cookieValue]);

  useEffect(() => {
    dispatch(employeeSearchAction(''));
  }, [dispatch]);

  const [hasDashboardMenu, setHasDashboardMenu] = useState(true);
  useEffect(() => {
    if (typeof profile != 'undefined') {
      setSubmitterName(profile.firstName + ' ' + profile.lastName);
    }
    if (profile && profile.allowedModules) {
      const hasDashboard = profile.allowedModules.some(
        (module) => module.value.trim() === 'dashboard' && module.operations.includes('menu')
      );
      if (hasDashboard == false) {
        setHasDashboardMenu(false);
      }
    }
  }, [profile]);

  const formData1 = {
    dynamicFields: {
      employeeName: 'Obinna Patrick',
      employeeNumber: '003890',
      date: new Date('12/10/2001'),
      phoneNumber: '9876543021',
      chargeCode: 'test1',
      courseType: 'test1-courseType',
      program: 'IT',
      educationalBackground: 'test',
      nameOfTrainingProgram: 'test',
      location: 'Online',
      descriptionOfTrainingProgram: 'important test',
      trainingStart: new Date('09/11/2004'),
      trainingEnds: new Date('10/12/2005'),
      trainingCost: 10,
      trainingJustification: 'justification test',
    },
  };
  useEffect(() => {
    if (id) {
      showLoader();
      getFormById(id)
        .then((formData) => {
          formData = formData1;
          if (formData) {
            getUsersSearch(formData.dynamicFields.employeeName.split(' ')[0])
              .then((response) => {
                const options = response.data.map((employee) => ({
                  value: employee.displayName || `${employee.firstName} ${employee.lastName}`,
                  label: employee.displayName || `${employee.firstName} ${employee.lastName}`,
                  email: employee.email,
                  employeeNumber: employee.employeeNumber,
                }));
                setEmpListDefault(options);
              })
              .catch((error) => {
                console.error('Error fetching employee data', error);
              });
            // Updating initial values based on fetched form data
            setInitialValues({
              submitter: profile ? profile.firstName + ' ' + profile.lastName : '',
              employeeName: {
                value: formData.dynamicFields.employeeName,
                label: formData.dynamicFields.employeeName,
              },
              employeeNumber: formData.dynamicFields.employeeNumber,
              date: moment(formData.dynamicFields.date).toDate(),
              phoneNumber: formData.dynamicFields.phoneNumber,
              chargeCode: {
                value: formData.dynamicFields.chargeCode,
                label: formData.dynamicFields.chargeCode,
              },
              courseType: {
                value: formData.dynamicFields.courseType,
                label: formData.dynamicFields.courseType,
              },
              program: formData.dynamicFields.program,
              educationalBackground: formData.dynamicFields.educationalBackground,
              nameOfTrainingProgram: formData.dynamicFields.nameOfTrainingProgram,
              location: formData.dynamicFields.location,
              descriptionOfTrainingProgram: formData.dynamicFields.descriptionOfTrainingProgram,
              trainingStart: moment(formData.dynamicFields.trainingStart).toDate(),
              trainingEnds: moment(formData.dynamicFields.trainingEnds).toDate(),
              trainingCost: formData.dynamicFields.trainingCost,
              trainingJustification: formData.dynamicFields.trainingJustification,
            });
          }
        })
        .catch(() => {
          console.log();
        })
        .finally(() => {
          hideLoader();
        });
    }
  }, [id]);

  const loadOptions = (inputValue, callback) => {
    if (!inputValue) {
      callback([]);
      return;
    }
    getUsersSearch(inputValue)
      .then((response) => {
        const options = response.data.map((employee) => ({
          value: employee.displayName || `${employee.firstName} ${employee.lastName}`,
          label: employee.displayName || `${employee.firstName} ${employee.lastName}`,
          email: employee.email,
          employeeNumber: employee.employeeNumber,
        }));
        callback(options);
      })
      .catch((error) => {
        console.error('Error fetching employee data', error);
        callback([]);
      });
  };

  const handleEmployeeChange = async (selectedOption, setFieldValue) => {
    setFieldValue(`employeeName`, selectedOption);
    const folderIdRes = await getBoxFolderOfEmpByEmail(selectedOption.email);
    if (typeof folderIdRes.isError != 'undefined' && folderIdRes.isError == true) {
      Swal.fire({
        icon: 'error',
        title: 'Employee Data Error',
        text: 'Employee data not configured with box, Please contact your admin',
        width: 400,
        confirmButtonColor: '#3a7afe',
      });

      setFieldValue(`email`, '');
      setFieldValue(`employeeNumber`, '');
      setFieldValue(`boxFolderId`, '');
      return false;
    }
    console.log('selected option ', selectedOption);
    setFieldValue(`boxFolderId`, folderIdRes.folderId || '0');
    setFieldValue(`employeeNumber`, selectedOption.employeeNumber || 'NA');
    setFieldValue(`email`, selectedOption.email);
  };

  const handleUploadBatch = async (data) => {
    const payload = {
      submitterName: profile ? profile.firstName + ' ' + profile.lastName : '',
      submitterEmail: profile.email,
      status: 'in progress',
      formType: 'training-form',
      contractor: 'ssai',
      dynamicFields: [{ ...data }],
    };
    if (
      localStorage.getItem('formDataJSON') == null ||
      typeof localStorage.getItem('formDataJSON') == 'undefined'
    ) {
      localStorage.setItem('formDataJSON', await storeData(payload));
    }

    const formData = await retrieveData(parseInt(localStorage.getItem('formDataJSON')));

    if (formData) {
      const payload = {
        data: formData.dynamicFields,
        key: cookieValue || '',
        isBoxExplorer: hasPermission('box-folders', ['show']) || false,
      };
      try {
        showLoader();
        const response = await uploadFileBatch(payload);
        if (Array.isArray(formData.dynamicFields)) {
          formData.dynamicFields.forEach((data, index) => {
            if (index === formData.dynamicFields.length - 1) {
              dispatch(createFormAction({ ...formData, dynamicFields: data }, navigate));
            } else {
              dispatch(createFormAction({ ...formData, dynamicFields: data }, undefined));
            }
          });
        } else {
          hasDashboardMenu == true ? navigate('/dashboard') : navigate('/forms');
        }

        Swal.fire({
          icon: 'success',
          title: 'Request submitted',
          text: 'Your request is submitted please wait for approver',
          width: 400,
          confirmButtonColor: '#3a7afe',
        }).then(() => {
          hasDashboardMenu == true ? navigate('/dashboard') : navigate('/forms');
        });
      } catch (error) {
        if (
          typeof error.response != 'undefined' &&
          typeof error.response.status != 'undefined' &&
          error.response.status == '501'
        ) {
          Swal.fire({
            icon: 'error',
            title: 'Employee Data Error',
            text: 'Employee data not exist on box, Please contact your admin',
            width: 400,
            confirmButtonColor: '#3a7afe',
          });
          hasDashboardMenu == true ? navigate('/dashboard') : navigate('/forms');
        } else {
          Swal.fire({
            icon: 'error',
            title: 'Request not submitted',
            text: 'Please contact your admin',
            width: 400,
            confirmButtonColor: '#3a7afe',
          });
          console.error(
            'Error uploading file:',
            error.response ? error.response.data : error.message
          );
        }
      } finally {
        hideLoader();
      }
    } else {
      Swal.fire({
        icon: 'error',
        title: 'Data not existed',
        text: 'Please contact your admin',
        width: 400,
        confirmButtonColor: '#3a7afe',
      });
      hasDashboardMenu == true ? navigate('/dashboard') : navigate('/forms');
    }
  };

  const handleSubmit = (data) => {
    if (typeof data != 'undefined') {
      const payloadForms = {
        ...data,
        submitter: profile ? profile.firstName + ' ' + profile.lastName : '',
        employeeName: data.employeeName.value,
      };
      handleUploadBatch(payloadForms);
    }
  };

  return (
    <>
      <PageTitle pageTitle="Edit Application for Training" />
      <Card>
        <Formik
          initialValues={initialValues}
          validationSchema={validationSchema}
          enableReinitialize={true}
          onSubmit={handleSubmit}
        >
          {({ values, setFieldValue, isSubmitting }) => (
            <FormikForm>
              <Row className="mb-3" style={{ flexWrap: 'nowrap' }}>
                <Col>
                  <div className="form-group">
                    <label htmlFor="employeeName">Employee Name</label>
                    <AsyncSelect
                      name="employeeName"
                      loadOptions={loadOptions}
                      defaultOptions={employeeList}
                      placeholder="Select Employee Name"
                      isSearchable
                      onChange={(selectedOption) =>
                        handleEmployeeChange(selectedOption, setFieldValue)
                      }
                      value={values.employeeName}
                    />
                    <ErrorMessage name="employeeName" component="div" className="text-danger" />
                  </div>
                </Col>
                <Col>
                  <div className="form-group">
                    <label htmlFor="employeeNumber">Employee Number</label>
                    <Field
                      type="text"
                      name="employeeNumber"
                      className="form-control"
                      placeholder="Employee Number"
                      value={values.employeeNumber}
                    />
                    <ErrorMessage name="employeeNumber" component="div" className="text-danger" />
                  </div>
                </Col>
              </Row>
              <Row className="mb-3" style={{ flexWrap: 'nowrap' }}>
                <Col>
                  <div className="form-group">
                    <label htmlFor="date">Date</label>
                    <DatePicker
                      selected={values.date}
                      onChange={(date) => {
                        setFieldValue('date', date);
                      }}
                      className="form-control"
                      dateFormat="MM/dd/yyyy"
                      placeholderText="MM/DD/YYYY"
                      value={values.date}
                    />
                    <ErrorMessage name="date" component="div" className="text-danger" />
                  </div>
                </Col>
                <Col>
                  <div className="form-group">
                    <label htmlFor="phoneNumber">Phone Number</label>
                    <Field
                      type="text"
                      name="phoneNumber"
                      className="form-control"
                      placeholder="123-456-7890"
                      value={values.phoneNumber}
                    />
                    <ErrorMessage name="phoneNumber" component="div" className="text-danger" />
                  </div>
                </Col>
              </Row>
              <Row className="mb-3" style={{ flexWrap: 'nowrap' }}>
                <Col>
                  <div className="form-group">
                    <label htmlFor="chargeCode">Charge Code</label>
                    <Select
                      name="chargeCode"
                      options={[
                        {
                          label: 'test1',
                          value: 'test1',
                        },
                        {
                          label: 'test2',
                          value: 'test2',
                        },
                      ]}
                      placeholder="Select Charge Code"
                      isSearchable
                      onChange={(selectedOption) =>
                        setFieldValue('chargeCode', selectedOption.label)
                      }
                      value={values.chargeCode}
                    />
                    <ErrorMessage name="chargeCode" component="div" className="text-danger" />
                  </div>
                </Col>
                <Col>
                  <div className="form-group">
                    <label htmlFor="courseType">CourseType</label>
                    <Select
                      name="courseType"
                      options={[
                        {
                          label: 'test1-courseType',
                          value: 'test1',
                        },
                        {
                          label: 'test2-courseType',
                          value: 'test2',
                        },
                      ]}
                      placeholder="Select Course Type"
                      isSearchable
                      onChange={(selectedOption) =>
                        setFieldValue('courseType', selectedOption.label)
                      }
                      value={values.courseType}
                    />
                    <ErrorMessage name="courseType" component="div" className="text-danger" />
                  </div>
                </Col>
                <Col>
                  <div className="form-group">
                    <label htmlFor="program">Program</label>
                    <Field
                      type="text"
                      name="program"
                      className="form-control"
                      placeholder="Program / Department"
                      value={values.program}
                    />
                    <ErrorMessage name="program" component="div" className="text-danger" />
                  </div>
                </Col>
              </Row>
              <Row className="mb-3" style={{ flexWrap: 'nowrap' }}>
                <Col>
                  <div className="form-group">
                    <label htmlFor="educationalBackground">Educational Background</label>
                    <Field
                      as="textarea"
                      name="educationalBackground"
                      className="form-control"
                      placeholder="Educational Background"
                      value={values.educationalBackground}
                    />
                    <ErrorMessage
                      name="educationalBackground"
                      component="div"
                      className="text-danger"
                    />
                  </div>
                </Col>
              </Row>
              <Row className="mb-3" style={{ flexWrap: 'nowrap' }}>
                <Col>
                  <div className="form-group">
                    <label htmlFor="nameOfTrainingProgram">Name of Training Program</label>
                    <Field
                      type="text"
                      name="nameOfTrainingProgram"
                      className="form-control"
                      placeholder="Name of Training Program"
                      value={values.nameOfTrainingProgram}
                    />
                    <ErrorMessage
                      name="nameOfTrainingProgram"
                      component="div"
                      className="text-danger"
                    />
                  </div>
                </Col>
                <Col>
                  <div className="form-group">
                    <label htmlFor="location">Location</label>
                    <Field
                      type="text"
                      name="location"
                      className="form-control"
                      placeholder="Location/Institution name"
                      value={values.location}
                    />
                    <ErrorMessage name="location" component="div" className="text-danger" />
                  </div>
                </Col>
              </Row>
              <Row className="mb-3" style={{ flexWrap: 'nowrap' }}>
                <Col>
                  <div className="form-group">
                    <label htmlFor="descriptionOfTrainingProgram">
                      Description of Training Program
                    </label>
                    <Field
                      as="textarea"
                      name="descriptionOfTrainingProgram"
                      className="form-control"
                      placeholder="Description of Training Program"
                      value={values.descriptionOfTrainingProgram}
                    />
                    <ErrorMessage
                      name="descriptionOfTrainingProgram"
                      component="div"
                      className="text-danger"
                    />
                  </div>
                </Col>
                <Col>
                  <div className="form-group">
                    <label htmlFor="trainingJustification">Training Justification</label>
                    <Field
                      as="textarea"
                      name="trainingJustification"
                      className="form-control"
                      placeholder="Training Justification"
                      value={values.trainingJustification}
                    />
                    <ErrorMessage
                      name="trainingJustification"
                      component="div"
                      className="text-danger"
                    />
                  </div>
                </Col>
              </Row>
              <Row className="mb-3" style={{ flexWrap: 'nowrap' }}>
                <Col>
                  <div className="form-group">
                    <label htmlFor="trainingStart">Training Start</label>
                    <DatePicker
                      selected={values.trainingStart}
                      onChange={(trainingStart) => {
                        setFieldValue('trainingStart', trainingStart);
                      }}
                      className="form-control"
                      dateFormat="MM/dd/yyyy"
                      placeholderText="MM/DD/YYYY"
                      value={values.trainingStart}
                    />
                    <ErrorMessage name="trainingStart" component="div" className="text-danger" />
                  </div>
                </Col>
                <Col>
                  <div className="form-group">
                    <label htmlFor="trainingEnds">Training Ends</label>
                    <DatePicker
                      selected={values.trainingEnds}
                      onChange={(trainingEnds) => {
                        setFieldValue('trainingEnds', trainingEnds);
                      }}
                      className="form-control"
                      dateFormat="MM/dd/yyyy"
                      placeholderText="MM/DD/YYYY"
                      value={values.trainingEnds}
                    />
                    <ErrorMessage name="trainingEnds" component="div" className="text-danger" />
                  </div>
                </Col>
                <Col>
                  <div className="form-group">
                    <label htmlFor="trainingCost">Training Cost ($)</label>
                    <div className="input-group">
                      <span className="input-group-text">$</span>
                      <Field
                        type="number"
                        name="trainingCost"
                        className="form-control"
                        placeholder="Training Cost"
                        min="0"
                        step="1"
                        value={values.trainingCost}
                      />
                    </div>
                    <ErrorMessage name="trainingCost" component="div" className="text-danger" />
                  </div>
                </Col>
              </Row>
              <div className="d-flex justify-content-end mt-4">
                <Button variant="primary" type="submit">
                  Re-Submit
                </Button>
              </div>
            </FormikForm>
          )}
        </Formik>
      </Card>
    </>
  );
};

const mapStateToProps = (state) => ({
  profile: getProfile(state),
  employeeList: employeeSearchList(state),
});

export default connect(mapStateToProps)(TrainingFormEdit);
